import React from 'react'
import { GestionAtencionProvider } from './GestionAtencionContext'
import GestionAtencion from '../../project/components/gestion-atencion/GestionAtencion'

const GestionAtencionProvided = () => {
  return (
    <GestionAtencionProvider>
      <GestionAtencion />
    </GestionAtencionProvider>
  )
}

export default GestionAtencionProvided